<template>
    <div class="wrap-collapsible">
        <input :id="id" class="toggle collapser" :name="name" :type="type">
        <label :for="id" class="lbl-toggle" :class="{'big': labelSize == 'big', 'small': labelSize != 'big'}">
            {{ labelText }}
        </label>
        <div class="collapsible-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            labelSize: {
                type: String,
                default: 'small'
            },
            labelText: {
                type: String,
                required: true
            },
            name: {
                type: String
            },
            type: {
                type: String,
                default: 'checkbox'
            }
        },
        data () {
            return {
                id: null
            }
        },
        mounted () {
            this.id = this._uid
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';

    .collapser {
        display: none;
    }

    .lbl-toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        transition: all 0.25s ease;
    }

    .lbl-toggle:hover {
        color: $primary;
    }

    .lbl-toggle::after {
        content: '›';
        font-size: 1.5em;

        transition: transform .2s ease-out;
    }

    .collapsible-content {
        max-height: 0px;
        overflow: hidden;

        transition: max-height .25s ease-in-out;
    }

    .toggle:checked + .lbl-toggle.big + .collapsible-content {
        max-height: 1000px;
    }

    .toggle:checked + .lbl-toggle.small + .collapsible-content {
        max-height: 450px;
    }


    .toggle:checked + .lbl-toggle::after {
        transform: rotate(90deg) translateX(4px);
    }

    .big {
        font-size: 1.3em;
        font-weight: 800;
    }

    .small {
        font-size: 1em;
        font-weight: 600;
    }
</style>